import { useEffect } from "react";
import { Mail, Phone, Clock } from "lucide-react";

const Contact = () => {
  const email = "info@grainly.in.net";

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen py-12 bg-gradient-to-br from-[#B7E5CD]/10 to-[#8ABEB9]/10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In Touch
          </h1>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Ready to connect? Reach out directly through email. We're
            here to help with all your rice needs.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {/* Email Card */}
          <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#305669] to-[#1785A] rounded-full flex items-center justify-center mb-4">
                <Mail className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Email Us
              </h3>
              <p className="text-gray-600 mb-4">Send us a message anytime</p>
              <a
                href={`mailto:${email}?subject=Inquiry from Rice Bazaar&body=Hi there, I'd like to get in touch...`}
                className="text-[#305669] hover:text-[#1785A] font-medium text-lg break-all transition-colors duration-200"
              >
                {email}
              </a>
            </div>
          </div>
        </div>

        {/* Business Hours */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="flex items-center justify-center mb-6">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mr-4">
              <Clock className="h-7 w-7 text-purple-600" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-900">
              Business Hours
            </h2>
          </div>
          <div className="space-y-3 max-w-md mx-auto">
            <div className="flex justify-between items-center py-2 border-b border-gray-200">
              <span className="text-gray-700 font-medium">
                Monday - Saturday
              </span>
              <span className="text-gray-900 font-semibold">
                9:00 AM - 8:00 PM
              </span>
            </div>
            <div className="flex justify-between items-center py-2">
              <span className="text-gray-700 font-medium">Sunday</span>
              <span className="text-gray-900 font-semibold">
                10:00 AM - 6:00 PM
              </span>
            </div>
          </div>
        </div>

        {/* Response Notice */}
        <div className="mt-8 text-center">
          <div className="bg-[#B7E5CD]/30 rounded-lg p-6">
            <p className="text-gray-700 text-sm sm:text-base">
              <strong className="text-[#305669]">Quick Response:</strong> We
              typically respond within 24 hours.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
